var _defs, _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarPanelEquiv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.09 75.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #04abc1;\n      }\n\n      .cls-2 {\n        fill: #e4f8fb;\n      }\n\n      .cls-3 {\n        fill: #82d9e3;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 36.55,
    cy: 37.63,
    r: 29.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.55,67.13c-16.27,0-29.5-13.23-29.5-29.5s13.23-29.5,29.5-29.5,29.5,13.23,29.5,29.5-13.23,29.5-29.5,29.5ZM36.55,9.63c-15.44,0-28,12.56-28,28s12.56,28,28,28,28-12.56,28-28-12.56-28-28-28Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    className: "cls-1",
    d: "M29.32,26.3l.1-1.18h-5.45c-.28,0-.52.19-.58.47l-1.56,7.47h6.9l.58-6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    className: "cls-1",
    d: "M28.06,41.01l.58-6.76h-7.05l-1.5,7.23c-.06.32.14.63.46.69,0,0,0,0,0,0,.04,0,.08.01.11.01h7.29l.11-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    className: "cls-1",
    d: "M35.96,42.19v-7.94h-6.14c-.07.82-.62,7.31-.68,7.94h6.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    className: "cls-1",
    d: "M35.96,25.13h-5.36c-.06.6-.62,7.15-.68,7.94h6.04v-7.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    className: "cls-1",
    d: "M51.5,34.25h-7.05l.58,6.77.1,1.18h7.3c.18,0,.35-.08.46-.22.11-.14.15-.32.12-.49l-1.51-7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    className: "cls-1",
    d: "M51.25,33.07l-1.56-7.47c-.05-.27-.29-.47-.57-.47h-5.45c.06.6.61,7.15.68,7.94h6.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    className: "cls-1",
    d: "M42.59,26.31l-.11-1.18h-5.35v7.94h6.03l-.58-6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    className: "cls-1",
    d: "M43.84,41.01l-.58-6.76h-6.13v7.94h6.81l-.1-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    className: "cls-1",
    d: "M45.96,46.31h-7.5v-2.94h-3.82v2.94h-7.5c-.98,0-1.77.79-1.77,1.76h0v1.47c0,.33.26.59.59.59h21.18c.32,0,.59-.26.59-.59v-1.47c0-.97-.79-1.76-1.77-1.76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPanelEquiv);
export default __webpack_public_path__ + "static/media/Solar Panel Equiv..de8b82499867932a8658f6b1857d6205.svg";
export { ForwardRef as ReactComponent };